import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = "/api/v1/admin/friends";

const Friends = () => {
    const [friendsData, setFriendsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState({ userId: "", friendId: "" });
    const [modalOpen, setModalOpen] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => { fetchFriends(); }, []);

    const fetchFriends = () => {
        setLoading(true);
        axios.get(API_URL)
            .then(res => setFriendsData(res.data.friends))
            .finally(() => setLoading(false));
    };

    const handleAdd = () => {
        setForm({ userId: "", friendId: "" });
        setModalOpen(true);
    };

    const handleSubmit = () => {
        setSaving(true);
        axios.post(API_URL, form).then(() => {
            fetchFriends();
            setModalOpen(false);
        }).finally(() => setSaving(false));
    };

    const handleRemove = (userId, friendId) => {
        axios.delete(API_URL, { data: { userId, friendId } }).then(fetchFriends);
    };

    return (
        <div className="p-4">
            <button
                className="mb-4 px-4 py-2 bg-Pookie-500 text-white rounded hover:bg-Pookie-600 transition"
                onClick={handleAdd}
            >
                Add Friend
            </button>
            {loading ? (
                <div className="flex justify-center items-center h-40">
                    <div className="w-8 h-8 border-4 border-Pookie-200 border-t-Pookie-500 rounded-full animate-spin" />
                </div>
            ) : (
                <div className="overflow-x-auto bg-white rounded-xl shadow">
                    <table className="min-w-full text-sm">
                        <thead>
                            <tr className="bg-gray-100 text-gray-600 uppercase text-xs">
                                <th className="py-3 px-4 text-left">User</th>
                                <th className="py-3 px-4 text-left">Friends</th>
                                <th className="py-3 px-4 text-left">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {friendsData.map((row, idx) => (
                                <tr key={idx} className="border-t hover:bg-gray-50">
                                    <td className="py-2 px-4">{typeof row.user === 'object' ? row.user.fullName : row.user}</td>
                                    <td className="py-2 px-4">{row.friends.map(f => f.fullName).join(", ")}</td>
                                    <td className="py-2 px-4">
                                        {row.friends.map(f => (
                                            <button
                                                key={f._id}
                                                className="px-3 py-1 bg-Pookie-500 text-white rounded hover:bg-Pookie-600 text-xs mr-2 mb-1"
                                                onClick={() => handleRemove(row.user._id, f._id)}
                                            >
                                                Remove
                                            </button>
                                        ))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Modal */}
            {modalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                    <div className="bg-white rounded-xl shadow-lg w-full max-w-md p-6 relative">
                        <button
                            className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-xl"
                            onClick={() => setModalOpen(false)}
                        >
                            &times;
                        </button>
                        <h2 className="text-lg font-bold mb-4 text-Pookie-600">Add Friend</h2>
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium mb-1">User ID</label>
                                <input
                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-Pookie-200"
                                    value={form.userId}
                                    onChange={e => setForm({ ...form, userId: e.target.value })}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium mb-1">Friend ID</label>
                                <input
                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-Pookie-200"
                                    value={form.friendId}
                                    onChange={e => setForm({ ...form, friendId: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="flex justify-end gap-2 mt-6">
                            <button
                                className="px-4 py-2 bg-Pookie-500 text-white rounded hover:bg-Pookie-600"
                                onClick={handleSubmit}
                                disabled={saving}
                            >
                                {saving ? "Adding..." : "Add"}
                            </button>
                            <button
                                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                                onClick={() => setModalOpen(false)}
                                disabled={saving}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Friends; 